import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from './CustomContent';
import LumeniaBrandPanel from './LumeniaBrandPanel';
import styles from './index.module.scss';

/**
 * Lumenia 托管认证界面：品牌分栏（冻结原型方案 B，G1 通过）。
 *
 * 相对上游的两处改动：
 * 1. 卡片由单栏改为「品牌栏 + 任务栏」两栏；窄屏（≤900px）收敛成单栏堆叠，
 *    品牌栏降为顶条。断点值与原型一致（900 / 560 / 480），@container → @media。
 * 2. 停止渲染 LogtoSignature（供应商署名）。托管页署的是 Lumenia 的名，
 *    开源合规由 public/open-source-notice.txt 与 index.html 的注释承担。
 *
 * 保留不动：usePlatform 的平台分支、CustomContent 的渲染点与 !isMobile 条件、
 * <Outlet/>，以及 logto_page-container / logto_main-content / logto_custom-content
 * 三个稳定类（另外两个 logto_signature / logto_branding-header 的定义在
 * src/utils/consts.ts，该文件不可改，仍原样保留）。
 */
const AppLayout = () => {
  const { theme } = useContext(PageContext);
  const { isMobile } = usePlatform();

  return (
    <div className={styles.viewBox}>
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
        <div className={styles.shell}>
          <LumeniaBrandPanel theme={theme} />
          <main className={classNames(styles.main, layoutClassNames.mainContent)}>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
